import styled from "styled-components";

export const InfoDetailsStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  span strong {
    font-size: 15px;
  }
`;
